import { act } from '@testing-library/react';
import actions from './actions';

const initState = {
    currentUserProfile: {},
    loading : false,
    message: null,
    type: null,
    didLoading: false,
};

export default function fetchProfilesReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_PROFILE_REQUESTED:
            return {
                ...state,
                currentUserProfile: {},
                loading : true,
                didLoading: false,
            };
        case actions.FETCH_PROFILE_SUCCEEDED:
            return {
                ...state,
                currentUserProfile    : action.profile,
                loading     : false,
                didLoading: true,
            };
        case actions.FETCH_PROFILE_FAILED:
            return {
                ...state,
                loading : false,
                didLoading: true,
            };
        case actions.UPDATE_PROFILE_REQUESTED:
            return {
                ...state,
                currentUserProfile: {},
                message: null,
                loading : true
            };
        case actions.UPDATE_PROFILE_SUCCEEDED:
            return {
                ...state,
                currentUserProfile : action.profile?.user_info,
                message : action.profile?.message,
                type : 'success',
                loading : false
            };
        case actions.UPDATE_PROFILE_FAILED:
            return {
                ...state,
                loading : false,
                message : action.error,
                type : 'danger',
            };
        case actions.CLEAR_ALERT_MESSAGE:
            return {
                ...state,
                message: null,
                type: null
            };
        default:
            return state;
    }
}
